<template>
    <v-form v-model="currentCustomQuestions.isValid">
        <v-container class="py-0 py-sm-0">
            <v-row>
                <v-col style="min-height: 445px;">
                    <div v-for="cq in customQuestions" v-bind:key="cq.questionText" class="mb-6">
                        <label class="mb-2">{{cq.questionText}}</label>
                        <v-btn-toggle v-model="cq.questionAnswer" v-bind:class="{'has-2-toggles': cq.answersSplit.length === 2, 'has-3-toggles': cq.answersSplit.length === 3}" required>
                            <v-btn v-for="answer in cq.answersSplit" v-bind:key="answer" :value="answer" large outlined color="primary" light>{{ answer }}</v-btn>
                        </v-btn-toggle>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'CustomQuestions',
        computed: {
            currentModel() {
                return this.$store.state.currentModel;
            },
            customQuestions() {
                return this.currentModel.settings.customQuestions;
            },
            currentCustomQuestions() {
                return this.$store.state.currentCustomQuestions;
            }
        }
    }
</script>
